<template>
  <b-modal
    v-model="visible"
    :busy="busy"
    show
    size="lg"
    @ok="onOk"
    @hide="onHide"
  >
    <template #modal-title>
      <b-card-title>Offerte</b-card-title>
      <b-card-sub-title>{{ offertePath }}</b-card-sub-title>
    </template>
    <b-overlay 
      :show="busy" 
      variant="dark"
    >
      <b-row>
        <b-col>
          <b-form-group label="Offertenummer">
            <b-input
              v-model="offerte.nummer"
              readonly
              placeholder="Automatisch gegenereerd"
            />
          </b-form-group>
          <b-form-group label="Datum">
            <b-datepicker 
              v-model="offerte.datum" 
              dark
            />
          </b-form-group>
          <b-form-group label="Bedrag">
            <b-input 
              v-model="offerte.bedrag" 
              type="number"
            />
          </b-form-group>
          <b-form-group label="Activiteiten">
            <b-checkbox-group
              v-model="offerte.activiteiten"
              :options="activiteiten"
              stacked
            />
          </b-form-group>
        </b-col>
        <b-col cols="8">
          <b-form-row>
            <b-col>
              <b-form-group label="Relatie">
                <relatie-select v-model="offerte.relatie" />
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group label="Accountmanager">
                <inspecteur-select
                  :value="offerte.toegewezen_aan"
                  :allow-beheerders="true"
                  :eigen-groep-alleen="true"
                  @input="offerte.toegewezen_aan = $event ? { Id: $event.id, Naam: $event.naam } : null"
                />
              </b-form-group>
            </b-col>
          </b-form-row>
          <b-form-group label="Naam">
            <b-input v-model="offerte.naam" />
          </b-form-group>
          <b-form-group label="Adres">
            <b-textarea v-model="offerte.adres" />
          </b-form-group>
          <b-form-group 
            :description="authDocPath" 
            label="Upload document"
          >
            <secure-upload
              v-if="offerte.bestand == null"
              :endpoint="authDocPath"
              subfolder="offertes"
              @file-uploaded="offerte.bestand = $event.document"
            />
            <b-button-toolbar v-else>
              <b-link 
                :href="offerte.bestand.secure_url" 
                target="_blank"
              >
                <font-awesome-icon icon="download" /> Download bestand
              </b-link>
              <b-link 
                class="ml-3 text-danger" 
                @click="offerte.bestand = null"
              >
                <i class="fa fa-trash" />
                verwijderen
              </b-link>
            </b-button-toolbar>
          </b-form-group>
          <b-form-group label="Notitie">
            <b-textarea v-model="offerte.omschrijving" />
          </b-form-group>
        </b-col>
      </b-row>
    </b-overlay>

    <template #modal-footer="{ ok, cancel }">
      <b-button 
        class="mr-auto" 
        variant="danger" 
        @click="onDelete"
      >
        Verwijderen
      </b-button>

      <b-button 
        variant="secondary" 
        @click="cancel()"
      >
        Annuleren
      </b-button>

      <b-button 
        variant="success" 
        @click="ok()"
      >
        Opslaan
      </b-button>
    </template>
  </b-modal>
</template>
<script>
import RelatieSelect from "../../../components/RelatieSelect.vue";
import SecureUpload from "../documenten/SecureUpload.vue";
import { serviceMixin } from "@/mixins/serviceMixin";
import { verkoopMixin } from "@/mixins/verkoopMixin";
import { mediaMixin } from "@/mixins/mediaMixin.js";
import FontAwesome from "../../icons/FontAwesome.vue";
import InspecteurSelect from "@/components/InspecteurSelect.vue";

export default {
  name: "Offerte",
  components: { SecureUpload, RelatieSelect, FontAwesome, InspecteurSelect },
  mixins: [serviceMixin, verkoopMixin, mediaMixin],
  props: {
    id: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      busy: false,
      visible: true,
      activiteiten: [
        "Liftmanagement",
        "0-inspectie / MJOP",
        "Rapport",
        "PLOH",
        "Nieuwbouw",
        "Advies",
        "Overige",
      ],
      offerte: {
        nummer: null,
        relatie: null,
        naam: null,
        adres: null,
        activiteiten: [],
        datum: null,
        bedrag: null,
        omschrijving: null,
        bestand: null,
        status: "OPENSTAAND",
      },
    };
  },
  computed: {
    offertePath: function () {
      if (this.id != null) return `/offertes/offerte/${this.id}`;
      return `/offertes/${this.offerte.status.toLowerCase()}`;
    },
    authDocPath: function () {
      return `/documenten/donkenliftadvies/${new Date().getUTCFullYear()}/authenticated`;
    },
  },
  watch: {
    id: {
      immediate: true,
      handler: function (newval) {
        console.log("trigger id", newval);
        if (newval !== null) this.getOfferte(newval);
      },
    },
  },
  methods: {
    onOk(modal) {
      modal.preventDefault();
      this.id == null ? this.insert() : this.update();
    },
    onHide(modal) {
      console.log(modal.trigger);
      if (modal.trigger !== "ok") this.goBack();
    },
    getOfferte(offerte_id) {
      console.log("ophalen...");
      var vm = this;
      this.getTraject("/offertes/offerte/" + offerte_id).then(function (
        response
      ) {
        console.log(response.data);
        vm.offerte = response.data.offerte;
      });
    },
    insert() {
      console.log("save...");
      var vm = this;
      this.createTraject(this.offertePath, { offerte: this.offerte }).then(
        function (response) {
          vm.emitUpdate(response.data.offerte);
        }
      );
    },
    update() {
      console.log("update...");
      var vm = this;
      this.updateTraject(this.offertePath, { offerte: this.offerte }).then(
        function (response) {
          console.log(response.data);
          vm.emitUpdate(response.data.offerte);
        }
      );
    },
    onDelete() {
      console.log("verwijderen...");
      var vm = this;
      this.deleteTraject(this.offertePath, { offerte: this.offerte }).then(
        function (response) {
          console.log(response.data);
          vm.emitDelete(vm.offerte);
        }
      );
    },
  },
};
</script>